import React from 'react';
import ReactDOM from 'react-dom';
import {InputText} from 'primereact/inputtext';
import Pagination from 'react-js-pagination';
import './EmpresaIndex.css';

const permissions = window.__EMPRESA_PERMISSIONS__ || {};

class EmpresaIndex extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            companies:  [],
            loading:    false,
            filters:    { name: '', cnpj: '' },
            pagination: { current_page: 1, per_page: 30, total: 0, from: 0, to: 0 },
        };
        this.fetchCompanies   = this.fetchCompanies.bind(this);
        this.handleSearch     = this.handleSearch.bind(this);
        this.handleClear      = this.handleClear.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleDelete     = this.handleDelete.bind(this);
    }

    componentDidMount() {
        this.fetchCompanies(1);
    }

    fetchCompanies(page = 1) {
        const { name, cnpj } = this.state.filters;
        this.setState({ loading: true });

        axios.get('/empresas-crud', { params: { page, name, cnpj } })
            .then(response => {
                const { data, current_page, per_page, total, from, to } = response.data;
                this.setState({
                    companies:  data,
                    loading:    false,
                    pagination: { current_page, per_page, total, from: from || 0, to: to || 0 },
                });
            })
            .catch(() => this.setState({ loading: false }));
    }

    handleSearch(e) {
        e.preventDefault();
        this.fetchCompanies(1);
    }

    handleClear() {
        this.setState({ filters: { name: '', cnpj: '' } }, () => this.fetchCompanies(1));
    }

    handlePageChange(page) {
        this.fetchCompanies(page);
    }

    handleDelete(company) {
        if (!window.confirm(`Tem certeza que deseja excluir "${company.name}"?`)) return;

        const token = document.querySelector('meta[name="csrf-token"]')?.content || '';
        axios.post(`/empresa/${company.id}`, { _method: 'DELETE', _token: token })
            .then(() => this.fetchCompanies(this.state.pagination.current_page))
            .catch(() => alert('Erro ao excluir empresa.'));
    }

    nameTemplate(row) {
        return (
            <a href={`/empresa/${row.id}`} className="ei-company-link">
                {row.name}
            </a>
        );
    }

    actionsTemplate(row) {
        return (
            <div className="card">

                <div className="ei-actions">
                    {permissions.view && (
                        <a href={`/empresa/${row.id}`} className="btn btn-link btn-info btn-sm" title="Visualizar">
                            <i className="fas fa-eye"></i>
                        </a>
                    )}
                    {permissions.edit && (
                        <a href={`/empresa/${row.id}/edit`} className="btn btn-link btn-warning btn-sm" title="Editar">
                            <i className="fas fa-edit"></i>
                        </a>
                    )}
                    {permissions.delete && (
                        <button
                            className="btn btn-link btn-danger btn-sm"
                            title="Excluir"
                            onClick={() => this.handleDelete(row)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { companies, loading, filters, pagination } = this.state;

        const thStyle = {
            padding: '10px 12px',
            fontFamily: "'Archivo', sans-serif",
            fontSize: '16px',
            fontWeight: 700,
            fontStyle: 'normal',
            color: '#5B595B',
            border: 'none',
            textAlign: 'left',
            whiteSpace: 'nowrap',
        };

        const tdStyle = {
            padding: '5px 6px',
            fontSize: '13px',
            color: '#555',
            border: '1px solid #dee2e6',
            verticalAlign: 'middle',
        };

        return (
            <div className="form-group row">

                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-6">

                                </div>
                                <div className="col-12 col-sm-6 col-md-6 d-flex justify-content-end">
                                    {permissions.create && (
                                        <a href="/empresa/create" className="btn btn-primary btn-sm">
                                            <i className="fas fa-plus"></i> Nova empresa
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="empresa-index">
                        <form className="ei-filters" onSubmit={this.handleSearch}>
                            <div className="form-group row">
                               <div className="col-12 col-sm-4 col-md-4">
                                   <label className="ei-filter-label">Nome</label>
                                   <InputText
                                       value={filters.name}
                                       className="d-block w-100"
                                       onChange={e => this.setState({ filters: { ...filters, name: e.target.value } })}
                                       placeholder="Buscar por nome..."
                                   />
                               </div>

                                <div className="col-12 col-sm-4 col-md-4">
                                        <label>CNPJ</label>
                                        <InputText
                                            className="d-block w-100"
                                            value={filters.cnpj}
                                            onChange={e => this.setState({ filters: { ...filters, cnpj: e.target.value } })}
                                            placeholder="Buscar por CNPJ..."
                                        />
                               </div>

                                <div className="col-12 col-sm-3 col-md-3">
                                    <button type="submit" className="btn btn-sm btn-primary btn-block">
                                        <i className="fas fa-search"></i> Buscar
                                    </button>
                                </div>

                                <div className="col-12 col-sm-1 col-md-1">
                                    <button type="button" className="btn btn-sm btn-block btn-outline-secondary" onClick={this.handleClear}>
                                        <i className="fa fa-times" />
                                    </button>
                                </div>

                            </div>
                        </form>
                        <hr />

                        <h5 style={{ fontWeight: 700, fontSize: '16px', color: '#333', marginBottom: '16px' }}>Empresas</h5>

                        {loading ? (
                            <div className="ei-loading">
                                <i className="fa fa-spinner fa-spin"></i> Carregando...
                            </div>
                        ) : (
                            <div style={{ overflowX: 'scroll' }}>

                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={thStyle}>Nome</th>
                                            <th style={thStyle}>CNPJ</th>
                                            <th style={thStyle}>Responsável</th>
                                            <th style={thStyle}>Contato</th>
                                            {(permissions.view || permissions.edit || permissions.delete) && (
                                                <th style={thStyle}>
                                                    Ações
                                                </th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {companies.length === 0 ? (
                                            <tr>
                                                <td colSpan={permissions.view || permissions.edit || permissions.delete ? 5 : 4} style={{ ...tdStyle, textAlign: 'center' }}>
                                                    Nenhuma empresa encontrada.
                                                </td>
                                            </tr>
                                        ) : (
                                            companies.map( (company, index) => (
                                                <tr key={company.id} style={{backgroundColor: index % 2 === 0 ? '#EEEFF0' : '#fff' }}>
                                                    <td style={tdStyle}>
                                                        <a href={`/empresa/${company.id}`} className="ei-company-link">
                                                            {company.name}
                                                        </a>
                                                    </td>
                                                    <td style={tdStyle}>{company.cnpj}</td>
                                                    <td style={tdStyle}>{company.owner}</td>
                                                    <td style={tdStyle}>{company.cellphone}</td>
                                                    {(permissions.view || permissions.edit || permissions.delete) && (
                                                        <td style={{ ...tdStyle, textAlign: 'right' }}>
                                                            {permissions.view && (
                                                                <a href={`/empresa/${company.id}`} className="btn btn-link btn-info btn-sm" title="Visualizar">
                                                                    <i className="fas fa-eye"></i>
                                                                </a>
                                                            )}
                                                            {permissions.edit && (
                                                                <a href={`/empresa/${company.id}/edit`} className="btn btn-link btn-warning btn-sm" title="Editar">
                                                                    <i className="fas fa-edit"></i>
                                                                </a>
                                                            )}
                                                            {permissions.delete && (
                                                                <button
                                                                    className="btn btn-link btn-danger btn-sm"
                                                                    title="Excluir"
                                                                    onClick={() => this.handleDelete(company)}
                                                                >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {pagination.total > pagination.per_page && (
                            <div className="ate-pagination d-flex justify-content-center" style={{ marginTop: '16px' }}>
                                <Pagination
                                    activePage={pagination.current_page}
                                    itemsCountPerPage={pagination.per_page}
                                    totalItemsCount={pagination.total}
                                    pageRangeDisplayed={7}
                                    onChange={this.handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </div>
                        )}
                    </div>
                </div>


                <style>{`
                            .ate-pagination .pagination {
                                gap: 4px;
                            }
                            .ate-pagination .page-link {
                                font-family: 'Archivo', sans-serif;
                                font-weight: bold;
                                font-size: 16px;
                                text-transform: uppercase;
                                border-radius: 0 !important;
                                border: 1px solid #999;
                                background-color: rgb(178, 178, 178);
                                color: #fff !important;
                                padding: 6px 14px;
                                letter-spacing: 0.04em;
                            }
                            .ate-pagination .page-item.active .page-link {
                                background-color: #4D5A31;
                                border-color: #4D5A31;
                                color: #fff;
                            }
                            .ate-pagination .page-link:hover {
                                background-color: rgb(140, 140, 140) !important;
                                border-color: rgb(140, 140, 140);
                                color: #fff !important;
                            }
                            .ate-pagination .page-item.active .page-link:hover {
                                background-color: #4D5A31;
                                border-color: #4D5A31;
                            }
                            .ate-pagination .pagination li:first-child .page-link,
                            .ate-pagination .pagination li:last-child .page-link {
                                background-color: rgb(178, 178, 178);
                                border-color: rgb(178, 178, 178);
                                color: #fff;
                            }
                            .ate-pagination .page-item.disabled .page-link {
                                background-color: rgb(178, 178, 178);
                                border-color: rgb(178, 178, 178);
                                color: #fff;
                                opacity: 0.6;
                            }
                            .ate-pagination .pagination li:first-child.disabled {
                                display: none;
                            }
                        `}</style>
            </div>
        );
    }
}

const mountPoint = document.getElementById('js-empresa-index');
if (mountPoint) {
    ReactDOM.render(<EmpresaIndex />, mountPoint);
}
